var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillOpacity: 0.8,
    fillRule: "evenodd",
    d: "M11.277 0C5.074 0 0 5.074 0 11.277a11.29 11.29 0 0 0 7.682 10.712c.564.07.775-.211.775-.564v-1.903c-3.171.705-3.805-1.48-3.805-1.48-.494-1.268-1.27-1.62-1.27-1.62-1.056-.705.071-.705.071-.705 1.128.07 1.762 1.127 1.762 1.127.987 1.692 2.608 1.198 3.313.916.07-.704.423-1.198.705-1.48-2.538-.282-5.145-1.268-5.145-5.567 0-1.198.423-2.256 1.127-3.03-.14-.283-.493-1.41.141-2.961 0 0 .917-.282 3.101 1.128.917-.282 1.833-.353 2.82-.353.986 0 1.902.141 2.819.353 2.184-1.48 3.1-1.198 3.1-1.198.635 1.55.212 2.678.142 2.96.704.775 1.127 1.762 1.127 3.03 0 4.3-2.607 5.286-5.145 5.568.423.352.776 1.057.776 2.114v3.101c0 .282.211.635.775.564a11.29 11.29 0 0 0 7.682-10.713C22.553 5.075 17.478 0 11.276 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo-02.114cb255d6c757f16035215cd033a2cb.svg";
export { ForwardRef as ReactComponent };